export var BATTLES_EVENT_TYPES = {
  ENTER_BATTLES_SCREEN: 'ENTER_BATTLES_SCREEN'
};